module.exports = __webpack_public_path__ + "img/44.c1376ead.png";